<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div>

			<div class="sc-products-sections">
				<div class="sc-products">
					<div class="sc-products-list-container">
						<ul class="sc-products-list">
							<li v-for="(item, index) in items" :class="{'sc-no-border':  item.course_id && is_auto_cart}">
								<template v-if="!item.replacement">
									<h2 v-if="item.bundled_products_for_multiple_courses">Multiple courses</h2>
									<h2 v-else-if="showCourseTitle(item)" :class="{'sc-course-title': is_auto_cart}"
										:aria-label="`Course code: ${item.course_code}, course name: ${item.course_name}`"
										role="heading" tabindex="0" aria-level="2"
									>
										{{ item.course_code }} &mdash; {{ item.course_name }}
									</h2>
									<div v-if="showCourseNotes(item)" class="sc-product-course-notes-container">
										<div class="product-disclaimer-container sc-product-disclaimer-container" v-if="item.course_notes">
											<span class="mdi mdi-information-outline"></span>
											<span class="sc-course-notes-text">View course notes</span>
											<span class="product-disclaimer-text" v-html="item.course_notes"></span>
										</div>
										<div v-if="item.show_syllabus_link" class="sc-product-syllabys">
											<a class="sc-ada-text" :href="`/syllabus_student.php?course_id=${item.course_id}`" target="_blank">View Syllabus</a>
										</div>
									</div>
									<v-container grid-list-md pa-0>
										<v-layout row wrap nowrap-sm>
											<v-flex sm2 xs4 offset-xs1 offset-sm0>
												<v-img
														:src="item.cover"
														height="120px"
														contain
														position="top left"
														v-bind="ADAattr('hidden')"
												></v-img>
											</v-flex>

											<v-flex xs6 sm8 px-3>
												<div v-if="$globs['detail_page_links_enabled']" class="mb-2 heading-4">
													<a
														:href="`/book/${item.isbn}/`"
														v-bind="ADAattr('label', ADAitemInCartLabel(item.title, item.isbn, item.is_required))"
													>
														{{ item.title }}
													</a>
												</div>
												<div v-else class="mb-2 heading-4" aria-level="3"
													v-bind="ADAattr('label', ADAitemInCartLabel(item.title, item.isbn, item.is_required))"
												>
													{{ item.title }}
												</div>
												<div v-if="item.condition === 'ebook'" tabindex="0" role="heading" aria-level="3">Delivered Electronically</div>
												<div tabindex="0">
													<span v-if="!item.variants">Condition:
													{{ item.condition_text + (item.condition_additional ? ' ' + item.condition_additional : '') }}</span>
													<v-select v-else
															v-model="item.product_type"
															label="Swap options"
															aria-label="Swap options"
															:items="item.variants"
															item-value="product_type"
															item-text="text"
															:ref="'product-condition-' + item.id"
															hide-no-data
															@change="item.replaceCondition"
															return-object
															class="sc-selector"
													>
														<template v-slot:selection>
																<div aria-hidden="true" tabindex="-1" aria-label="Swap Options" role="listbox" class="v-btn sc-v-btn v-btn--block theme--dark sc-selector-item">Swap Options <span class="sc-selector-expand">keyboard_arrow_down</span></div>
														</template>
														<template v-slot:item="data">
																<div aria-hidden="true"  tabindex="-1" role="option" class="v-btn sc-v-btn v-btn--block theme--dark sc-selector-item"
																		v-bind="[
																			ADAattr('label', data.item.text)
																		]"
																>{{data.item.text}}</div>
														</template>
														<template v-slot:prepend><div tabindex="0" role="textbox">Condition: <span>{{ item.condition_text + (item.condition_additional ? ' ' + item.condition_additional : '') }}</span></div></template>
													</v-select>
													<template v-if="item.condition === 'rental' && item.rental_due_date">
														<span v-bind="ADAattr('label', `, return by: ${ADAformatDate(item.rental_due_date)}`)">
															<span v-bind="ADAattr('hidden')">
																(Return by {{item.rental_due_date | formatDate}})
															</span>
														</span>
													</template>
												</div>
												<div v-if="item.condition === 'exchange' && is_auto_cart && item.seller_id" tabindex="0" role="heading" aria-level="3">
													Seller: <a :href="item.seller_link" target="_blank" class="sc-ada-text">{{item.seller_name}}, {{item.seller_state}}</a>
												</div>
												<div v-if="item.additional">Additional: {{ item.additional }}</div>
												<div v-if="item.condition === 'ebook' && item.licence && item.unlimited_vendor !== 'PearsonDIGITAL'" tabindex="0" role="heading" aria-level="3">
													{{item.licence}}
												</div>
												<div v-if="item.unlimited_vendor !== 'PearsonDIGITAL'" v-bind="ADAattr('hidden')">ISBN: {{ item.isbn }}</div>
												<div v-if="item.backorder" class="mt-2 mb-2 backorder-shipping">
													<div class="material-icons v-icon">event</div>
													<div v-bind="ADAattr('label', `${out_of_stock_label} ${out_of_stock_text}`)">
														<span class="out-of-stock-label">{{out_of_stock_label}}</span>
														<span>{{out_of_stock_text}}</span>
													</div>
												</div>
												<div v-if="item.disclaimer && item.unlimited_vendor !== 'PearsonDIGITAL'" class="product-disclaimer-container">
													<span aria-hidden="true" class="mdi mdi-information-outline"></span>
													<span>{{item.notice_label}}</span>
													<div class="product-disclaimer-text">
													  <div class="notice-bridge"></div>
													  <span v-html="item.disclaimer"></span>
													</div>
												</div>
												<template v-if="item.condition === 'rental'">
													<div class="rental-credit-card-required-msg">
														Credit card required.
														<a
															href="#"
															@click.prevent="showRentalDetailsDialog(item)"
															v-bind="ADAattr('button', 'Credit card required details')"
															:id="`ada-rd-${item.isbn}`"
														>Details</a>
													</div>
													<div v-if="item.buyout_price > 0">
														Buyout Price: ${{item.buyout_price}}.
														<span style="font-size: 0.8em">The additional amount you will be charged if you do not return your rental.</span>
													</div>
												</template>
												<div v-if="item.is_required" v-bind="ADAattr('hidden')">
													<div class="rbc-item-type rbc-item-type-required">
														<span class="rbc-item-type-icon">new_releases</span>
														<span>Required</span>
													</div>
												</div>
												<div v-if="is_international_shipping && ['rental', 'exchange'].includes(item.condition)">
													Note: {{item.condition_text}} items can only be shipped within the United States.
												</div>
											</v-flex>

											<v-flex xs12 sm2 px-3>
												<div
													class="sc-controls-info-block"
                          								role="heading"
                          								tabindex="0"
                          								aria-level="4"
													v-bind="[
														ADAattr('label', `Price per item: $${item.price}`)
													]"
												>
													<strong v-bind="ADAattr('hidden')">${{ item.price }}</strong>
												</div>
												<div v-if="item.condition !== 'rental' && !item.single_item_limit">
													<v-combobox
														v-model="item.quantity"
														label="Quantity"
														:items="getNumbers(Math.max(100, parseInt(item.quantity) + 10))"
														class="co-text-field"
														@keypress="validateQuantityInput"
														@change="updateQuantity(item)"
														:ref="'combobox-' + item.id"
														hide-no-data
														v-bind="ADAattr('list')"
													></v-combobox>
												</div>
												<div class="sc-controls-info-block">
													<a
														href="#"
														@click.prevent="removeProduct(item)"
														v-bind="ADAattr('button', 'Remove this item from cart')"
													>
														Remove
													</a>
												</div>
											</v-flex>
										</v-layout>
										<v-layout px-1 v-if="item.bundled_products.length">
                      <v-layout px-1 v-if="item.unlimited_vendor == 'CengageDIGITAL'">
                        <cengage-unlimited-carousel
                            :bundled_products="item.bundled_products"
                        ></cengage-unlimited-carousel>
                      </v-layout>
                      <v-layout px-1 v-if="item.unlimited_vendor === 'PearsonDIGITAL'">
                        <pearson-plus-carousel
                            :bundled_products="item.bundled_products"
                        ></pearson-plus-carousel>
                      </v-layout>
										</v-layout>
									</v-container>
								</template>
								<template v-else>
									<alternative-item-selector
											:item="item.replacement"
											:free_shipping_margin="free_shipping_margin"
											@add-to-cart="item.addToCart"
											id="ada-replacement"
									></alternative-item-selector>
								</template>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<v-dialog v-model="show_rental_dialog" width="500">
			<v-card v-bind="[
				ADAattr('dialog', !show_rental_dialog, `ada-rd-${_.get(dialog_item, 'isbn', '')}`),
				ADAfocus('show_rental_dialog')
			]">
				<v-card-text>
					<p>
						You may utilize financial aid to pay for your rental,
						but we require a valid credit card to secure your rental return.
					</p>
					<p>
						A Prepaid card may not be used for rental security.
					</p>
					<p v-if="dialog_item">
						If you don't have a credit card, please view
						<a :href="`/book/${dialog_item.isbn}/`" target="_blank">other options</a>
						for this item
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="#2170f2" flat="flat" @click="show_rental_dialog = false" v-bind="ADAattr('label', 'Return')">Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import _ from 'lodash';
	import AlternativeItemSelector from './../../common/components/vuejs/AlternativeItemSelector';
  import CengageUnlimitedCarousel from './CengageUnlimitedCarousel';
  import PearsonPlusCarousel from './PearsonPlusCarousel';

	export default {
		name: "CartBookList",

		components: {
			AlternativeItemSelector,
      CengageUnlimitedCarousel,
      PearsonPlusCarousel,
		},

		props: {
			products: {
				type: Array,
				default: [],
			},
			replacements: {
				type: Array,
			},
			free_shipping_margin: {
				type: Number,
				default: 0,
			},
			is_international_shipping: {
				type: Boolean,
				default: false
			},
			is_auto_cart: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				show_rental_dialog: false,
				dialog_item: null,
				out_of_stock_label: 'Temporarily Out of Stock.',
				out_of_stock_text: 'You will be notified when this item is available and shipped.',
			};
		},

		mounted() {
			this.addAriaLabelsToSwapOptions();
		},

		methods: {
			getNumbers: num => _.map(_.range(1, num), x => x.toString()),

			updateQuantity(item) {
				this.$refs['combobox-' + item.id][0].isMenuActive = false;
				if (!item.quantity) {
					item.quantity = 1;
					this.$forceUpdate();
				}
				this.$emit('changed-quantity', item);
			},

			removeProduct(item) {
				this.$emit('removed-item', item);
			},

			showRentalDetailsDialog(item) {
				this.dialog_item = item;
				this.show_rental_dialog = true;
			},
			validateQuantityInput(e) {
				if (isNaN(parseInt(e.key))){
					e.preventDefault();
				}
			},
			showCourseNotes(item) {
				return this.is_auto_cart && (item.course_notes || item.show_syllabus_link) && item.show_course_title;
			},
			showCourseTitle(item) {
				if(item.course_code) {
					if(this.is_auto_cart) {
						return item.show_course_title;
					}
					return true;
				}
				return false;
			},
			addAriaLabelsToSwapOptions() {
				if (!this.is_auto_cart) {
					return false;
				}
				// Cannot modify this via s-select props
				const elements = document.querySelectorAll('.sc-selector');
				elements.forEach((element) => {
					element.setAttribute('aria-label', `Book condition`);
				});
			}
		},

		watch: {
			replacements(value, old) {
				const self = this;

				_.forEach(self.products, product => {
					let ol_id = product['cart_line_id'];

					let idx = _.findIndex(value, v => v.cart_line_id === ol_id);
					if (idx >= 0) {
						product['replacement'] = value[idx];
					} else {
						product['replacement'] = null;
					}
				});

			},
		},

		computed: {
			items() {
				const self = this;

				return _.map(self.products, product => {
					product.addToCart = (payload) => {
						self.$emit('add-to-cart', {
							...payload,
							quantity: product.quantity,
							course_id: product.course_id || null,
							cart_line_id: product.cart_line_id,
						});
					};

					product.replaceCondition = (payload) => {
						self.$emit('replace-condition', {
							...payload,
							quantity: product.quantity,
							course_id: product.course_id || null,
							cart_line_id: product.cart_line_id,
						});
					};
					return product;
				});
			},
		},
		filters: {
			formatDate(date) {
				const d = new Date(date);
				return d.toLocaleDateString("en-US");
			},
		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.sc-products-sections {
		.sc-products {
			overflow: hidden;
			border-top: 1px solid #E0E0E0;

			&:first-child {
				border-top: none;
			}

			.sc-products-list-container {
				ul.sc-products-list {
					list-style: none;
					padding: 0 0;

					> li {
						overflow: hidden;
						padding: 10px 0;

						border-top: 1px solid #E0E0E0;

						h2 {
              				font-family: Roboto, sans-serif;
							color: #767676 !important;
							font-size: 16px !important;
							font-weight: normal !important;
							margin: 0 0 10px 0 !important;
							text-transform: uppercase !important;
              				padding: 0;
						}

						.heading-4 {
              				font-weight: bold;
							a {
								color: #000 !important;
							}
						}

						.copl-cover {
							display: block;
							float: left;
							width: 15%;
						}

						.copl-info {
							display: block;
							box-sizing: border-box;
							float: left;
							width: 85%;
							padding: 10px;

							div {
								font-size: 14px;
							}
						}

						.sc-controls-info-block {
							text-align: right;
						}

						/deep/ .v-autocomplete input[type=number] {
							-moz-appearance: textfield;
							text-align: center;

							&::-webkit-outer-spin-button,
							&::-webkit-inner-spin-button {
								-webkit-appearance: none;
								margin: 0;
							}
						}
						.backorder-shipping {
							display: flex;

							.v-icon, .out-of-stock-label {
								color: #2170f2
							}
              
							.v-icon {
								flex: 1 0 auto;
								align-items: baseline;
								margin-right: 5px;
							}
						}
					}
				}
			}
		}

		/deep/ .sc-shipping-method-container {
			width: 40%;
			float: left;
			font-size: 15px;

			.sc-select-shipping {
				.v-label {
					font-size: 15px;
				}
			}

			&.sc-shipping-method-container-selected {
				padding: 20px;
				box-sizing: border-box;
			}

			.sc-sm-header {
				font-size: 15px;
				font-weight: bold;

				strong {
					color: @text_highlight_color;
				}
			}

			.sc-estimated-delivery-container {
				width: 80%;
				border: 1px solid #E0E0E0;
				padding: 10px;
				margin-bottom: 20px;
			}
		}
	}

	.sc-submit-panel {
		padding-top: 15px;
		border-top: 1px solid #E0E0E0;
	}

	.rental-credit-card-required-msg {
		color: #E13100;

		span {
			color: black;
		}
	}

	.rbc-item-type {
		@icon_height: 38px;

		border-radius: @icon_height / 2;
		height: @icon_height;
		line-height: @icon_height;
		vertical-align: middle;
		text-align: center;
		padding: 0 15px 0 10px;
		display: inline-block;
		margin-top: 5px;

		&.rbc-item-type-required {
			background-color: #d4e4ff;
			color: #0d5cdf;
			font-size: 0;

			span {
				display: inline-block;
				font-size: 14px;
				height: @icon_height;
				line-height: @icon_height;
				vertical-align: middle;

				&.rbc-item-type-icon {
					font-family: 'Material Icons';
					font-size: 22px;
					margin-right: 5px;
					@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
						/* Support for IE */
						text-rendering: optimizeLegibility;
						font-feature-settings: 'liga';
						ms-font-feature-settings: 'liga'
					}
				}
			}
		}
	}
</style>
